"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresenterSettings = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Tile = require("../Tile");
var _JoinComponent = require("../Join/JoinComponent.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _CameraPreview = require("../CameraPreview");
var _FormTextbox = require("../FormTextbox");
var _Button = require("../Button");
var _PresenterSettings = require("./PresenterSettings.styled");
var _PresenterSettingsMedia = _interopRequireDefault(require("./PresenterSettingsMedia"));
var _constants = require("@studio/constants");
var _PresenterSettingsMedia2 = require("./PresenterSettingsMedia.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * @description This will be named to PresenterSettings when the newJoinFlow flag is deprecated
 */
var PresenterSettings = exports.PresenterSettings = function PresenterSettings(_ref) {
  var _names$, _names$slice$join, _source$description, _source$title, _titleMap, _labelMap, _labelMap$source$type, _thumbnailMap, _titleMap$source$type, _thumbnailMap$source$;
  var source = _ref.source,
    meetingSession = _ref.meetingSession,
    attendeeTiles = _ref.attendeeTiles,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel;
  var names = source.title.split(' ');
  var _firstName = (_names$ = names[0]) !== null && _names$ !== void 0 ? _names$ : '';
  var _lastName = (_names$slice$join = names.slice(1).join(' ')) !== null && _names$slice$join !== void 0 ? _names$slice$join : '';
  var _description = (_source$description = source.description) !== null && _source$description !== void 0 ? _source$description : '';
  var _useState = (0, _react.useState)(_firstName),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    firstName = _useState2[0],
    setFirstName = _useState2[1];
  var _useState3 = (0, _react.useState)(_lastName),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    lastName = _useState4[0],
    setLastName = _useState4[1];
  var _useState5 = (0, _react.useState)(_description),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    description = _useState6[0],
    setDescription = _useState6[1];
  var _useState7 = (0, _react.useState)((_source$title = source.title) !== null && _source$title !== void 0 ? _source$title : ''),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    title = _useState8[0],
    setTitle = _useState8[1];
  var hasFirstNameExceededLimit = firstName.trim().length > 30;
  var hasLastNameExceededLimit = lastName.trim().length > 50;
  var hasDescriptionExceededLimit = description.trim().length > 80;
  var presenterTitle = "".concat(firstName, " ").concat(lastName);
  var hasPresenterTitle = presenterTitle.trim().length > 0;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    var source_title = source.type === _constants.CAMERA_PRESENTER ? "".concat(firstName, " ").concat(lastName) : title;
    var payload = {
      source_title: source_title,
      description: description
    };
    onSubmit(payload);
  };
  var videoNode = _react["default"].createElement(_PresenterSettings.CameraView, null, _react["default"].createElement(_Tile.AttendeeTile, {
    attendeeId: source.value,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    isCameraOn: true
  }));
  var hasValidationError = !hasPresenterTitle || hasFirstNameExceededLimit || hasLastNameExceededLimit || hasDescriptionExceededLimit;
  var titleMap = (_titleMap = {}, (0, _defineProperty2["default"])(_titleMap, _constants.VIDEO_FILE, 'Edit video file settings'), (0, _defineProperty2["default"])(_titleMap, _constants.SCREEN_PRESENTER, 'Edit screen share settings'), (0, _defineProperty2["default"])(_titleMap, _constants.PDF_FILE, 'Rename file'), (0, _defineProperty2["default"])(_titleMap, _constants.CAMERA_PRESENTER, 'Settings'), (0, _defineProperty2["default"])(_titleMap, _constants.AUDIO_FILE, 'Edit audio settings'), (0, _defineProperty2["default"])(_titleMap, _constants.IMAGE_FILE, 'Edit image settings'), _titleMap);
  var labelMap = (_labelMap = {}, (0, _defineProperty2["default"])(_labelMap, _constants.VIDEO_FILE, 'Video name'), (0, _defineProperty2["default"])(_labelMap, _constants.SCREEN_PRESENTER, 'Screen share name'), (0, _defineProperty2["default"])(_labelMap, _constants.PDF_FILE, ''), (0, _defineProperty2["default"])(_labelMap, _constants.CAMERA_PRESENTER, 'Name'), (0, _defineProperty2["default"])(_labelMap, _constants.AUDIO_FILE, 'Audio name'), (0, _defineProperty2["default"])(_labelMap, _constants.IMAGE_FILE, 'Image name'), _labelMap);
  var SettingsFormContent = _react["default"].createElement(_reactstrap.Row, null, _react["default"].createElement(_reactstrap.Col, {
    md: 12
  }, _react["default"].createElement(_FormTextbox.FormTextbox, {
    labelText: (_labelMap$source$type = labelMap[source.type]) !== null && _labelMap$source$type !== void 0 ? _labelMap$source$type : 'Media name',
    id: "title",
    "data-testid": "source-title",
    value: title,
    required: true,
    onChange: function onChange(event) {
      return setTitle(event.target.value);
    }
  })));
  var CameraPresenterFormContent = _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_reactstrap.Row, null, _react["default"].createElement(_reactstrap.Col, {
    md: 6
  }, _react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "firstName",
    id: "firstName",
    labelText: "First name",
    value: firstName,
    required: true,
    onChange: function onChange(event) {
      return setFirstName(event.target.value);
    },
    hasError: hasFirstNameExceededLimit,
    errorMessage: hasFirstNameExceededLimit && "First Name can't exceed 30 characters"
  })), _react["default"].createElement(_reactstrap.Col, {
    md: 6
  }, _react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "lastName",
    id: "lastName",
    labelText: "Last name",
    value: lastName,
    required: true,
    onChange: function onChange(event) {
      return setLastName(event.target.value);
    },
    hasError: hasLastNameExceededLimit,
    errorMessage: hasLastNameExceededLimit && "Last Name can't exceed 50 characters"
  }))), _react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "title",
    id: "title",
    labelText: "Title",
    value: description,
    onChange: function onChange(event) {
      return setDescription(event.target.value);
    },
    hasError: hasDescriptionExceededLimit,
    errorMessage: hasDescriptionExceededLimit && "Title can't exceed 80 characters"
  }));
  var PresenterSourceThumbnail = _react["default"].createElement(_JoinComponent.StyledCameraPreviewWrapper, null, _react["default"].createElement(_CameraPreview.CameraPreview, {
    presenterTitle: presenterTitle,
    presenterDescription: description,
    videoNode: videoNode,
    meetingSession: meetingSession,
    browserBlock: false
  }));
  var thumbnailMap = (_thumbnailMap = {}, (0, _defineProperty2["default"])(_thumbnailMap, _constants.PDF_FILE, _react["default"].createElement(_react["default"].Fragment, null)), (0, _defineProperty2["default"])(_thumbnailMap, _constants.CAMERA_PRESENTER, PresenterSourceThumbnail), (0, _defineProperty2["default"])(_thumbnailMap, _constants.SCREEN_PRESENTER, _react["default"].createElement(_PresenterSettings.CameraView, null, videoNode)), _thumbnailMap);
  return _react["default"].createElement(_JoinComponent.StyledPresenterSettingsCardBody, null, _react["default"].createElement(_PresenterSettingsMedia2.StyledPresenterSettingsCardContent, null, _react["default"].createElement(_reactstrap.CardTitle, {
    tag: "h4"
  }, (_titleMap$source$type = titleMap[source.type]) !== null && _titleMap$source$type !== void 0 ? _titleMap$source$type : 'Edit media settings'), _react["default"].createElement(_PresenterSettings.ThumbnailWrapper, null, (_thumbnailMap$source$ = thumbnailMap[source.type]) !== null && _thumbnailMap$source$ !== void 0 ? _thumbnailMap$source$ : _react["default"].createElement(_PresenterSettingsMedia["default"], {
    source: source
  })), _react["default"].createElement(_react["default"].Fragment, null, source.type === _constants.CAMERA_PRESENTER ? CameraPresenterFormContent : SettingsFormContent)), _react["default"].createElement(_JoinComponent.StyledCardFooter, null, _react["default"].createElement(_Button.Button, {
    onClick: onCancel,
    color: "outline",
    className: "me-2",
    "data-testid": "cancel"
  }, "Cancel"), _react["default"].createElement(_Button.Button, {
    disabled: hasValidationError,
    onClick: handleSubmit,
    color: "primary",
    "data-testid": "submit"
  }, "Done")));
};
PresenterSettings.propTypes = {
  source: _propTypes["default"].object.isRequired,
  meetingSession: _propTypes["default"].object.isRequired,
  attendeeTiles: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired
};